import {BehaviorSubject} from "rxjs";
import {EventEmitter} from "@angular/core";
import {HttpParams} from "@angular/common/http";
import {IFilter} from "../services/IFilter";
import {AuthService} from "../services/auth.service";

export class NeFilter implements IFilter {

  anyChange:EventEmitter<any> = new EventEmitter<any>();

  constructor(private auth: AuthService) {
    this.clear();
  }

  nameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get name():any {
    return this.nameChange.value;
  }
  set name(name:any) {

    this.nameChange.next(name);
    this.emitChange("name", name);
  }

  netIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get netId():any {
    return this.netIdChange.value;
  }
  set netId(netId:any) {

    this.netIdChange.next(netId);
    this.emitChange("netId", netId);
  }

  siteIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get siteId():any {
    return this.siteIdChange.value;
  }
  set siteId(siteId:any) {

    this.siteIdChange.next(siteId);
    this.emitChange("siteId", siteId);
  }

  hostChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get host():any {
    return this.hostChange.value;
  }
  set host(host:any) {

    this.hostChange.next(host);
    this.emitChange("host", host);
  }

  environmentIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get environmentId():any {
    return this.environmentIdChange.value;
  }
  set environmentId(environmentId:any) {

    this.environmentIdChange.next(environmentId);
    this.emitChange("environmentId", environmentId);
  }

  locationIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get locationId():any {
    return this.locationIdChange.value;
  }
  set locationId(locationId:any) {

    this.locationIdChange.next(locationId);
    this.emitChange("locationId", locationId);
  }

  companyIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get companyId():any {
    return this.companyIdChange.value;
  }
  set companyId(companyId:any) {

    this.companyIdChange.next(companyId);
    this.emitChange("companyId", companyId);
  }

  clusterIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get clusterId():any {
    return this.clusterIdChange.value;
  }
  set clusterId(clusterId:any) {
    this.clusterIdChange.next(clusterId);
    this.emitChange("clusterId", clusterId);
  }

  emitChange(prop:string, value:any):void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  getParams():HttpParams {
    let params:HttpParams = new HttpParams();
    if (this.companyId && this.companyId !== '') {
      params = params.set("companyId", this.companyId);
    }

    if (this.name && this.name !== '') {
      params = params.set("name", this.name);
    }

    if (this.host && this.host !== '') {
      params = params.set("host", this.host);
    }

    if (this.environmentId && this.environmentId !== '') {
      params = params.set("environmentId", this.environmentId);
    }

    if (this.locationId && this.locationId !== '') {
      params = params.set("locationId", this.locationId);
    }

    if (this.netId && this.netId !== '') {
      params = params.set("netId", this.netId);
    }

    if (this.siteId && this.siteId !== '') {
      params = params.set("siteId", this.siteId);
    }

    if (this.clusterId && this.clusterId !== '') {
      params = params.set("clusterId", this.clusterId);
    }
    return params;
  }

  setFilters(props: any): void {
    this.clusterIdChange.next(props.clusterId || undefined);
    this.companyIdChange.next(props.companyId === undefined ? this.auth.getCompanyId() : props.companyId || undefined);
    this.nameChange.next(props.name || undefined);
    this.hostChange.next(props.host || undefined);
    this.environmentIdChange.next(props.environmentId || undefined);
    this.locationIdChange.next(props.locationId || undefined);
    this.netIdChange.next(props.netId || undefined);
    this.siteIdChange.next(props.siteId || undefined);
  }

  toObj() {
    let obj:any = {
      companyId: this.companyId,
      netId: this.netId,
      siteId: this.siteId,
      name: this.name,
      host: this.host,
      environmentId: this.environmentId,
      locationId: this.locationId,
      clusterId: this.clusterId,
    };
    return obj;
  }

  public clear():void {
    this.clusterId = undefined;
    this.companyId = this.auth.getCompanyId();
    this.netId = undefined;
    this.siteId = undefined;
    this.name = undefined;
    this.host = undefined;
    this.environmentId = undefined;
    this.locationId = undefined;
  }
}
